import { DataSource, Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiStatusCodeQuickInfo extends Layout {
    labelT: Label;
    labelXmitSequence: Label;
    sourceEdistatus: DataSource;
    textboxCreateDate: Textbox;
    textboxCreateUserId: Textbox;
    textboxSourceRecordType: Textbox;
    textboxStandardDescription: Textbox;
    textboxUpdateDate: Textbox;
    textboxUpdateUserId: Textbox;
}
